import { call, put } from 'redux-saga/effects';

import { Notifications } from 'types';

import { webSocketService } from 'services/WebSocketService';
import { changeCardsAction, changeCardsFailureAction } from 'data/reducers';
import { ActionType } from 'typesafe-actions';
import { responseType } from 'constants/common';

export function* changeCardsSaga({
  payload: { shiftManagerId, cards },
}: ActionType<typeof changeCardsAction>) {
  const { type, data } = yield call(() =>
    webSocketService.sendMessage({
      type: Notifications.CHANGE_CARDS,
      data: { shiftManagerId, cards },
    }),
  );

  if (type === responseType.Error) {
    yield put(changeCardsFailureAction(data));
  }
}
